import { useEffect } from "react";

// Click outside any [data-card-tile] / [data-keep-focus] region.
// Uses the bubble phase so React onClick handlers (e.g. primary-action
// buttons) run before the focus clears.
export function useClickOutsideCards(enabled: boolean, onOutside: () => void) {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: MouseEvent) => {
      const target = e.target;
      if (!(target instanceof Element)) return;
      if (target.closest("[data-card-tile]")) return;
      if (target.closest("[data-keep-focus]")) return;
      onOutside();
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, [enabled, onOutside]);
}
